import { render, staticRenderFns } from "./leaving-a-job.vue?vue&type=template&id=226e1424"
import script from "./leaving-a-job.vue?vue&type=script&lang=js"
export * from "./leaving-a-job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports